import { Component, OnInit, ViewChild } from '@angular/core';

import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
// import { ToastrManager } from 'ng6-toastr-notifications';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from "ngx-spinner";
import { MainService } from '../../emb/service/main.service'
import { MainService as MDService } from '../../md/service/main.service';
import { MainService as mainServiceAdmin } from '../../admin/service/main.service';
declare var $: any;
import Swal from 'sweetalert2';
import { session } from '../../../environments/environment.session'

@Component({
  selector: 'app-workflow-definition',
  templateUrl: './workflow-definition.component.html',
  styleUrls: ['./workflow-definition.component.css']
})
export class WorkflowDefinitionComponent implements OnInit {


  constructor(private mainServiceEMB: MainService, private mainServiceAdmin: mainServiceAdmin, private mainServiceMd: MDService, private spinner: NgxSpinnerService, private toastr: ToastrService) {

  }
  @ViewChild(MatPaginator, { static: false }) paginator!: MatPaginator;
  @ViewChild(MatSort, { static: false }) sort!: MatSort;

  doc_type: any = [
    { module: 'EMB', value: 'EBILL' }, { module: 'EMB', value: 'EMB' }, { module: 'EMB', value: 'CB' }, { module: 'EMB', value: 'INCEPTION' }, { module: 'EMB', value: 'ESTIMATE' },
    { module: 'OPERATION', value: 'WORK ORDER' }, { module: 'OPERATION', value: 'VENDOR_BILL' },
    // {module:'HR', value: 'SAL_BILL' },{module:'HR', value: 'EXTRA_WORK'},
    // {module:'PROPERTY', value: 'OFFER' },{module:'PROPERTY', value: 'PROPERTY' },{module:'PROPERTY', value: 'PLANLAYOUT' },{module:'PROPERTY', value: 'APPLICATION' },{module:'ICMS', value: 'INSPECTION REPORT'},{module:'ICMS', value: 'MAP DOCUMENT'},

    { module: 'HR', value: 'SAL_BILL' }, { module: 'HR', value: 'EXTRA_ARREAR_BILL' }, { module: 'HR', value: 'EXTRA_WORK' }, { module: 'HR', value: 'ACR' }, { module: 'HR', value: 'ADV_BILL' }, { module: 'HR', value: 'MED_BILL' },
    { module: 'PROPERTY', value: 'OFFER' }, { module: 'PROPERTY', value: 'PROPERTY' }, { module: 'PROPERTY', value: 'PLANLAYOUT' }, { module: 'PROPERTY', value: 'APPLICATION' }, { module: 'PROPERTY', value: 'AUCTION' },
    { module: 'ICMS', value: 'INSPECTION REPORT' }, { module: 'ICMS', value: 'MAP DOCUMENT' }, { module: 'ICMS', value: 'DEFENDENT DOCS' }, { module: 'ICMS', value: 'ORDER EXECUTION REPORT' },
    { module: 'USTP', value: 'USTP_DEMAND' }, { module: 'INVENTORY', value: 'Note Sheet' }, { module: 'INVENTORY', value: 'Rate_Discovery' },
    { module: 'EMD', value: 'TENDER REPORT' }, { module: 'EMD', value: 'ASSIGN TENDER' },

    { module: 'ACCOUNT', value: 'JV' }, { module: 'ACCOUNT', value: 'BP' },
    { module: 'ACCOUNT', value: 'CB' }, { module: 'ACCOUNT', value: 'SALARY_BILL' },
    { module: 'ACCOUNT', value: 'VENDOR_BILL_OPERATION' }, { module: 'ACCOUNT', value: 'MANUAL_JOURNAL' },
    { module: 'PR', value: 'CERTIFICATE_ISSUED' }, { module: 'NOC', value: 'CTP' }
    , { module: 'NOC', value: 'ENGINEERING' }, { module: 'NOC', value: 'PROPERTY' },
    { module: 'NOC', value: 'TAX' }, { module: 'NOC', value: 'BILL' }, { module: 'NOC', value: 'ACCOUNTANT' },
    { module: 'ADVERTISEMENT', value: 'ADVERTIS_APPICATION' } , {module: 'NOC', value: 'CARTOGRAPHER'}

  ]

  l_flow_flag: any = true;
  c_flow_flag: any = false;
  u_flow_flag: any = false;
  isLinear: any = false;
  first: any = true;
  second: any = true;
  third: any = true;
  indeterminate: any;
  labelPosition: any;
  disabled: any;
  logicalCondition: any = [{ value: 'AND' }, { value: 'OR' }]

  roleFunction: any = [{ code: 'Forward', value: 'Forward' }, { code: 'Down Marking', value: 'Down Marking' },
  { code: 'Approval', value: 'Approval' }, { code: 'Payment', value: 'Payment' }, { code: 'Info', value: 'Info' }]

  successAction = [{ code: 'Approve & Forward', value: 'Approve & Forward' }, { code: 'Down Mark for Approval', value: 'Down Mark for Approval' }, { code: 'Approve', value: 'Approve' },
  { code: 'Note & Forward', value: 'Note & Forward' }, { code: 'Email', value: 'Email' }, { code: 'SMS', value: 'SMS' }]


  displayedColumns: any = ['id', 'doc_type', 'module_cd', 'action'];
  datasource: any;
  mainService: any = {}
  FlowObj: any = { data: [] }
  erpUser: any
  b_acct_id: any;
  // checked=false;

  allModule: any = [];

  selectedModuleForWorkFlow: any;
  async ngOnInit() {
    console.log("Work----------------------------Flow")

    this.selectedModuleForWorkFlow = this.mainServiceMd.selectedModuleForCommonWorkFlow;
    console.log("Work----------------------------Flow for--->" + this.selectedModuleForWorkFlow);

    this.doc_type = this.doc_type.filter((a: any) => a.module == this.selectedModuleForWorkFlow);
    console.log(this.doc_type)
    this.erpUser = JSON.parse(atob(session.erpUser)); this.b_acct_id = this.erpUser.b_acct_id;

    await this.gotolist();
    // await this.getAllModule();
    // await this.getRoles();
    // await this.getAllActiveWorkFlow();
    // await this.getAccountUserInfo()
  }
  async gotolist() {
    this.l_flow_flag = true;
    this.c_flow_flag = false;
    this.u_flow_flag = false;
    await this.getAllModule();
    await this.getRoles();
    await this.getAllActiveWorkFlow();
    await this.getAccountUserInfo();
  }




  /*********************************************New code Start ************************************************** */

  async addRowLevelForModule() {
    this.moduledata.push({
      level: this.moduledata.length + 1,
      branch: this.moduledata['level'] + 1,
      branch_data: [{
        level: this.moduledata.length + 1, branch: 1, branch_logical_condition: '', module_role: '', role_cd: '',
        role_function: '', success_action: '', condition_exists: false, sent_to_vendor: false, all_user_approval_req: false,
        data: []
      }]
    });

    await this.balancedWorkFlowData();

  }



  async addBranchForModule(level: any) {
    for (let i = 0; i < this.moduledata.length; i++) {
      if (this.moduledata[i]['level'] == level) {
        this.moduledata[i]['branch_data'].push({
          level: level, branch: this.moduledata[i]['branch_data'].length + 1, branch_logical_condition: '', module_role: '', role_cd: '',
          role_function: '', success_action: '', condition_exists: false, sent_to_vendor: false, all_user_approval_req: false,
          data: []
        })
      }
    }


    await this.balancedWorkFlowData();


  }


  async deleteRowFromMudule(k: any, l: any) {
    console.log(k, l);
    let data = await this.checkuser()
    let obj = this.moduledata[k]['branch_data'][l]
    let workflowdata = []
    console.log(this.moduledata[k]['branch_data'][l])
    for (let i = 0; i < data.length; i++) {
      if (this.FlowObj['doc_type'] == data[i]['doc_type']) {

        if (data[i]['level'] == obj['update_level'] && data[i]['branch'] == obj['update_branch']) workflowdata.push(data[i])
      }
    }

    console.log(workflowdata, obj)
    if (workflowdata.length > 0) {
      $('#viewuser').modal('show');
      this.workflowdata = workflowdata
      return
    }
    if (l == 0 && this.moduledata[k]['branch_data'].length == 1) {
      this.moduledata.splice(k, 1);
    } else {
      this.moduledata[k]['branch_data'].splice(l, 1);
    }
    await this.balancedWorkFlowData()

  }

  selectedModuleRole: any = [];
  changeModule(module_cd: any) {
    //console.log(module_cd)
    if (module_cd == null || module_cd == undefined || module_cd == '') {
      this.selectedModuleRole = [];
    } else {
      this.selectedModuleRole = this.moduleToRoles[module_cd]
    }
  }
  /*********************************************New code End************************************************** */








  async getAllActiveWorkFlow() {
    let obj: any = new Object();
    obj['b_acct_id'] = this.b_acct_id;
    obj['status'] = 'ACTIVE'
    var resp = await this.mainServiceMd.getdistinctDocumentWorkflows(JSON.stringify(obj));
    console.log(resp)
    if (resp['error'] == false) {
      console.log(resp.data);


      var data = []
      for (let i = 0; i < resp.data.length; i++) {
        if (resp.data[i]['module_cd'] == this.selectedModuleForWorkFlow) {
          data.push(resp.data[i])
        }
      }
      console.log(data)

      this.datasource = new MatTableDataSource(data)
      this.datasource.paginator = this.paginator;
      this.datasource.sort = this.sort;
    }
  }


  roles: any = []
  allRoles: any = [];
  allRolesForEMB: any = []
  async getRoles() {
    var resp = await this.mainServiceMd.getApprovalroles(JSON.stringify({ b_acct_id: this.b_acct_id }));
    console.log(resp)
    if (resp['error'] == false) {
      console.log(resp.data);
      this.roles = resp.data
      for (let i = 0; i < resp.data.length; i++) {
        if (resp.data[i]['is_system_role'] == 0) {
          if (resp.data[i]['module_cd'] == this.selectedModuleForWorkFlow) {
            this.allRolesForEMB.push(resp.data[i])
          } else {
            this.allRoles.push(resp.data[i])
          }
        }
      }
    }
  };


  Module: any = [];
  allModuleForEMB: any = []
  moduleToRoles: any = {}
  async getAllModule() {
    let obj: any = new Object();
    obj['b_acct_id'] = 0;
    var resp = await this.mainServiceMd.getModules(JSON.stringify(obj));
    console.log(resp)
    if (resp['error'] == false) {
      console.log(resp.data)
      var AdminModule = resp.data;
      var assignedModule = this.erpUser.assigned_product_cd;

      console.log(assignedModule)
      console.log(AdminModule)
      console.log(this.selectedModuleForWorkFlow)
      this.Module = [];
      this.allModule = [];
      this.allModuleForEMB = [];

      for (let i = 0; i < AdminModule.length; i++) {
        this.moduleToRoles[AdminModule[i]['module_cd']] = [];
        for (let j = 0; j < assignedModule.length; j++) {
          if (assignedModule[j] == AdminModule[i]['module_cd']) {
            this.Module.push(AdminModule[i])
            if (AdminModule[i]['module_cd'] == this.selectedModuleForWorkFlow) {
              this.allModuleForEMB.push(AdminModule[i])
            } else {
              this.allModule.push(AdminModule[i])
            }
          }
        }
      }
      console.log(this.allModuleForEMB)
    }
  };


  refresh() {
    this.moduledata = [];
    this.crossmoduledata1 = [];
    this.Apprmoduledata = [];
  }
  users: any = []

  userObj: any = {};
  async getAccountUserInfo() {
    let obj: any = new Object();
    obj['b_acct_id'] = this.b_acct_id;
    obj['module_cd'] = this.selectedModuleForWorkFlow;
    console.log(obj)
    var resp = await this.mainServiceMd.getuserformodulerolemapping(JSON.stringify(obj));
    if (resp['error'] == false) {
      this.users = resp.data;
      console.log(this.users);
      for (let i = 0; i < this.users.length; i++) {
        this.userObj[this.users[i]['user_id']] = this.users[i]['emp_name']
        this.users[i]['desc'] = this.users[i]['user_id'] + " - " + this.users[i]['emp_name'] + " - " + this.users[i]['emp_phone_no']
      }
      console.log(this.userObj)
    }
  }
  workflowdata: any = []
  // async deleteRowFromMudule(i, j) {
  //   let data = await this.checkuser()
  //   let obj = this.moduledata[i]['branch_data'][0]
  //   let workflowdata = []
  //   for (let i = 0; i < data.length; i++) {
  //     if(this.FlowObj['doc_type'] == data[i]['doc_type']){
  //     if(data[i]['level'] == obj['update_level'] &&  data[i]['branch'] == obj['update_branch'])
  //     workflowdata.push(data[i])
  //     }
  //   }

  //   console.log(workflowdata,obj)
  //   if(workflowdata.length > 0){
  //     $('#viewuser').modal('show');
  //     this.workflowdata = workflowdata
  //  return
  //   }  console.log(i, j);
  //   this.moduledata.splice(i, 1);
  //   await this.balancedWorkFlowData();
  // }

  async checkuser() {

    let resp = await this.mainServiceEMB.getAllTaskOfUser(JSON.stringify({ status: 'PENDING', b_acct_id: this.b_acct_id }))

    if (resp['error'] == false) {
      let data = resp['data']
      return data
      console.log(data)
    }

  }
  async deleteRowFromCrossModule(i: any, j: any, k: any) {
    console.log(i, j);
    let data = await this.checkuser()
    let obj = this.crossmoduledata1[i]['level_data'][j]['branch_data'][k]
    let workflowdata = []
    console.log(this.crossmoduledata1[i]['level_data'][j]['branch_data'][k])
    // data.push({level:6.1,branch:4,doc_type:'CB'})
    for (let i = 0; i < data.length; i++) {
      if (this.FlowObj['doc_type'] == data[i]['doc_type']) {

        if (data[i]['level'] == obj['update_level'] && data[i]['branch'] == obj['update_branch']) workflowdata.push(data[i])



      }
    }


    if (workflowdata.length > 0) {
      $('#viewuser').modal('show');
      this.workflowdata = workflowdata
      return
    }
    if (k == 0 && this.crossmoduledata1[i]['level_data'][j]['branch_data'].length == 1) {
      this.crossmoduledata1[i]['level_data'].splice(j, 1);
    } else {
      this.crossmoduledata1[i]['level_data'][j]['branch_data'].splice(k, 1);
    }
    await this.balancedWorkFlowData()

  }

  async deleteRowFromApprMudule(i: any, j: any) {
    console.log(i, j);
    let data = await this.checkuser()
    let obj = this.Apprmoduledata[i]['branch_data'][0]
    let workflowdata = []
    //data.push({level:7,branch:1,doc_type:'CB'})
    for (let i = 0; i < data.length; i++) {
      if (this.FlowObj['doc_type'] == data[i]['doc_type']) {
        if (data[i]['level'] == obj['update_level'] && data[i]['branch'] == obj['update_branch']) workflowdata.push(data[i])
      }
    }

    console.log(workflowdata, obj)
    if (workflowdata.length > 0) {
      $('#viewuser').modal('show');
      this.workflowdata = workflowdata
      return
    }
    this.Apprmoduledata.splice(i, 1);
    await this.balancedWorkFlowData()
  }
  async deleteLevel(i: any) {
    let data = await this.checkuser()
    let obj = this.crossmoduledata1[i]['level_data'][0]['branch_data']
    let workflowdata = []
    console.log(this.crossmoduledata1[i]['level_data'][0]['branch_data'])
    // data.push({level:6.1,branch:4,doc_type:'CB'})
    for (let i = 0; i < data.length; i++) {
      if (this.FlowObj['doc_type'] == data[i]['doc_type']) {
        for (let j = 0; j < obj.length; j++) {
          if (data[i]['level'] == obj[j]['update_level'] && data[i]['branch'] == obj[j]['update_branch']) workflowdata.push(data[i])

        }

      }
    }

    console.log(workflowdata, obj)
    if (workflowdata.length > 0) {
      $('#viewuser').modal('show');
      this.workflowdata = workflowdata
      return
    }
    this.crossmoduledata1.splice(i, 1);
    await this.balancedWorkFlowData()

  }

  //for module
  moduledata: any = [];

  // async addRowLevelForModule() {
  //   this.moduledata.push({
  //     level: this.moduledata.length + 1,
  //     branch_data: [{
  //       level: this.moduledata.length + 1, branch: 1, branch_logical_condition: '', module_role: '', role_cd: '',
  //       role_function: '', success_action: '', condition_exists: false, sent_to_vendor: false, all_user_approval_req: false,
  //       data: []
  //     }]
  //   });


  //   await this.balancedWorkFlowData();

  // }

  async addRowBranchForModule(i: any, j: any) {
    this.moduledata[i]['branch_data'].push({
      level: i + 1,
      branch: this.moduledata[i]['branch_data'].length + 1, branch_logical_condition: '', module_role: '', role_cd: '',
      role_function: '', success_action: '', condition_exists: false, sent_to_vendor: false, all_user_approval_req: false, data: []
    });
    await this.balancedWorkFlowData();


  }


  //for crooss-module

  crossmoduledata1: any = [];


  async addCrossModule() {
    this.crossmoduledata1.push({
      module: this.moduledata.length + this.crossmoduledata1.length + 1,
      module_show: true,
      level_data: [
        {
          level: this.moduledata.length + 1 + this.crossmoduledata1.length + 0.1,
          branch_data: [{
            level: this.moduledata.length + 1 + this.crossmoduledata1.length + 0.1, branch: 1, branch_logical_condition: '', module_role: '', role_cd: '',
            role_function: '', success_action: '', condition_exists: false, sent_to_vendor: false, all_user_approval_req: false,
            data: []
          }]
        }
      ]
    });

    await this.balancedWorkFlowData();

  }
  async addLevel(module: any) {
    for (let i = 0; i < this.crossmoduledata1.length; i++) {
      if (this.crossmoduledata1[i]['module'] == module) {
        this.crossmoduledata1[i]['level_data'].push({
          level: (module + (this.crossmoduledata1[i]['level_data'].length + 1) * (0.10)),
          branch_data: [{
            level: (module + (this.crossmoduledata1[i]['level_data'].length + 1) * (0.10)), branch: 1, branch_logical_condition: '', module_role: '', role_cd: '',
            role_function: '', success_action: '', condition_exists: false, sent_to_vendor: false, all_user_approval_req: false,
            data: []
          }]
        })
      }
    }

    await this.balancedWorkFlowData();

  }
  async addBranch(module: any, level: any) {
    for (let i = 0; i < this.crossmoduledata1.length; i++) {
      if (this.crossmoduledata1[i]['module'] == module) {

        for (let j = 0; j < this.crossmoduledata1[i]['level_data'].length; j++) {

          if (this.crossmoduledata1[i]['level_data'][j]['level'] == level) {

            this.crossmoduledata1[i]['level_data'][j]['branch_data'].push({
              level: level, branch: this.crossmoduledata1[i]['level_data'][j]['branch_data'].length + 1, branch_logical_condition: '', module_role: '', role_cd: '',
              role_function: '', success_action: '', condition_exists: false, sent_to_vendor: false, all_user_approval_req: false,
              data: []
            })
          }
        }
      }
    }


    await this.balancedWorkFlowData();


  }

  //**********************************************for approval module***********************************************/
  Apprmoduledata: any = [];

  async addRowLevelForApprModule() {

    var lvl = this.moduledata.length + this.crossmoduledata1.length + this.Apprmoduledata.length + 1;

    this.Apprmoduledata.push({
      level: lvl,
      branch_data: [{
        level: lvl, branch: 1, branch_logical_condition: '', module_role: '', role_cd: '',
        role_function: '', success_action: '', condition_exists: false, sent_to_vendor: false, all_user_approval_req: false,
        data: []
      }]
    });

    await this.balancedWorkFlowData();

  }


  balancedWorkFlowData() {



    for (let i = 0; i < this.moduledata.length; i++) {
      this.moduledata[i]['level'] = i + 1;
      for (let j = 0; j < this.moduledata[i]['branch_data'].length; j++) {
        this.moduledata[i]['branch_data'][j]['branch'] = j + 1;
      }
      // this.moduledata[i]['branch_data'][0]['level'] = i + 1;
    }


    for (let i = 0; i < this.crossmoduledata1.length; i++) {
      this.crossmoduledata1[i]['module'] = (this.moduledata.length + i) + 1;

      for (let j = 0; j < this.crossmoduledata1[i]['level_data'].length; j++) {
        this.crossmoduledata1[i]['level_data'][j]['level'] = (this.moduledata.length + i) + 1 + (0.1 * (j + 1));

        for (let k = 0; k < this.crossmoduledata1[i]['level_data'][j]['branch_data'].length; k++) {

          this.crossmoduledata1[i]['level_data'][j]['branch_data'][k]['level'] = (this.moduledata.length + i) + 1 + (0.1 * (j + 1));
          this.crossmoduledata1[i]['level_data'][j]['branch_data'][k]['branch'] = k + 1;

        }
      }
    }

    for (let i = 0; i < this.Apprmoduledata.length; i++) {
      this.Apprmoduledata[i]['level'] = this.moduledata.length + this.crossmoduledata1.length + i + 1;
      this.Apprmoduledata[i]['branch_data'][0]['level'] = this.moduledata.length + this.crossmoduledata1.length + i + 1;
    }


    console.log(this.moduledata);
    console.log(this.crossmoduledata1);
    console.log(this.Apprmoduledata);

  }



  conditionField: any = { EBILL: [{ value: 'Bill Amount', code: 'Bill Amount' }], EMB: [], CB: [{ value: 'Net Amount', code: 'net_amt' }] }
  oprater: any = [{ value: '>' }, { value: '<' }, { value: '>=' }, { value: '<=' }, { value: '==' }, { value: '!=' }]

  updateData: any = [];
  index_i: any = 0;
  index_j: any = 0;
  index_k: any = 0;
  data_type: any;

  condtion(i: any, j: any, k: any, type: any) {
    $('#condtion').modal('show');
    this.index_i = i;
    this.index_j = j;
    this.index_k = k;
    this.data_type = type;
    if (type == 'M') {
      this.updateData = this.moduledata[i]['branch_data'][j]['data'];
    } else if (type == 'CM') {
      this.updateData = this.crossmoduledata1[i]['level_data'][j]['branch_data'][k]['data'];
    } else {
      this.updateData = this.Apprmoduledata[i]['branch_data'][j]['data'];
    }
  }


  addConditionRow() {
    this.updateData.push({ selected_field: '', selected_oprater: '', value: 0 })
  }

  deleteConditionRow(i: any) {
    this.updateData.splice(i, 1)
  }

  saveCondition() {

    if (this.data_type == 'M') {
      this.moduledata[this.index_i]['branch_data'][this.index_j]['data'] = this.updateData;

    } else if (this.data_type == 'CM') {
      this.crossmoduledata1[this.index_i]['level_data'][this.index_j]['branch_data'][this.index_k]['data'] = this.updateData;

    } else {
      this.Apprmoduledata[this.index_i]['branch_data'][this.index_j]['data'] = this.updateData;
    }

    this.updateData = [];
    $('#condtion').modal('hide');
  }

  applyFilter(filterValue: string) {
    this.datasource.filter = filterValue.trim().toLowerCase();
  }

  allApproval: any
  allDocType: any = []

  changedoctype() {
    console.log(this.allDocType)
    for (let i = 0; i < this.allDocType.length; i++) {
      if (this.allDocType[i]['doc_type'] == this.FlowObj['doc_type']) {
        Swal.fire('Warning', 'This document type`s approval hierarchy is already exists..!', 'warning');
      }
    }
  }

  async submit() {


    console.log(this.moduledata);
    console.log(this.crossmoduledata1);
    console.log(this.Apprmoduledata);

    var data = [];
    for (let i = 0; i < this.moduledata.length; i++) {
      var pp = this.moduledata[i]['branch_data']
      for (let j = 0; j < pp.length; j++) {
        pp[j]['department'] = 'MODULE';
        data.push(pp[j])
      }
    }

    for (let i = 0; i < this.crossmoduledata1.length; i++) {
      var level_data = this.crossmoduledata1[i]['level_data']
      for (let j = 0; j < level_data.length; j++) {
        var branch_data = level_data[j]['branch_data']
        for (let k = 0; k < branch_data.length; k++) {
          branch_data[k]['department'] = 'CRROS-MODULE';
          data.push(branch_data[k])
        }
      }
    }

    for (let i = 0; i < this.Apprmoduledata.length; i++) {
      var pp = this.Apprmoduledata[i]['branch_data']
      for (let j = 0; j < pp.length; j++) {
        pp[j]['department'] = 'APPROVAL';
        data.push(pp[j])
      }
    }


    for (let i = 0; i < data.length; i++) {
      if (data[i]['condition_exists']) {
        data[i]['condition_exists'] = 1
      } else {
        data[i]['condition_exists'] = 0
      }

      if (data[i]['sent_to_vendor']) {
        data[i]['sent_to_vendor'] = 1
      } else {
        data[i]['sent_to_vendor'] = 0
      }

      if (data[i]['all_user_approval_req']) {
        data[i]['all_user_approval_req'] = 1
      } else {
        data[i]['all_user_approval_req'] = 0
      }
    }

    console.log(data)
    this.spinner.show();
    this.FlowObj['b_acct_id'] = this.b_acct_id;
    data.map(x => {
      x['role_cd'] = x['role_cd'].join(",");
    })
    this.FlowObj['data'] = data;
    this.FlowObj['module_cd'] = this.selectedModuleForWorkFlow;
    this.FlowObj['comment'] = this.selectedModuleForWorkFlow + ' ka work Flow';
    this.FlowObj['create_user_id'] = this.erpUser.user_id;
    this.FlowObj['status'] = 'ACTIVE';
    console.log(this.FlowObj)
    var resp = await this.mainServiceMd.createNewWorkflow(this.FlowObj);
    if (resp['error'] == false) {
      this.spinner.hide();
      await this.getAllActiveWorkFlow();

      this.toastr.success('Created Successfully ');
      this.gotolist()
    }
    else {
      this.spinner.hide();
      this.toastr.error(resp['data']);
    }

  }

  data: any = []
  async open_update(element: any) {
    console.log(element);
    let obj: any = new Object();
    obj['b_acct_id'] = this.b_acct_id;
    obj['status'] = 'ACTIVE';
    obj['doc_type'] = element['doc_type'];
    obj['module_cd'] = element['module_cd'];
    var resp = await this.mainServiceMd.getWorkflows(JSON.stringify(obj));
    console.log(resp)
    if (resp['error'] == false) {
      console.log(resp.data);
      resp.data.map((x: any) => {
        x['role_cd'] = x['role_cd'].split(",")
      })
      this.FlowObj['doc_type'] = resp.data[0]['doc_type'];


      var module_data: any = {}
      var apprval_data: any = {}
      var cross_module_data: any = {}
      for (let i = 0; i < resp.data.length; i++) {

        resp.data[i]['data'] = JSON.parse(resp.data[i]['data']);

        if (resp.data[i]['condition_exists'] == 1) {
          resp.data[i]['condition_exists'] = true
        } else {
          resp.data[i]['condition_exists'] = false
        }

        if (resp.data[i]['sent_to_vendor'] == 1) {
          resp.data[i]['sent_to_vendor'] = true
        } else {
          resp.data[i]['sent_to_vendor'] = false
        }

        if (resp.data[i]['all_user_approval_req'] == 1) {
          resp.data[i]['all_user_approval_req'] = true
        } else {
          resp.data[i]['all_user_approval_req'] = false
        }
        resp.data[i]['update_level'] = resp.data[i]['level']
        resp.data[i]['update_branch'] = resp.data[i]['branch']
        if (resp.data[i]['department'] == 'MODULE') {
          if (module_data[resp.data[i]['level']] == undefined) {
            module_data[resp.data[i]['level']] = { level: resp.data[i]['level'], branch_data: [resp.data[i]] }
          } else {
            module_data[resp.data[i]['level']]['branch_data'].push(resp.data[i])
          }
        }
        if (resp.data[i]['department'] == 'APPROVAL') {
          if (apprval_data[resp.data[i]['level']] == undefined) {
            apprval_data[resp.data[i]['level']] = { level: resp.data[i]['level'], branch_data: [resp.data[i]] }
          } else {
            apprval_data[resp.data[i]['level']]['branch_data'].push(resp.data[i])
          }
        }


        if (resp.data[i]['department'] == 'CRROS-MODULE') {
          if (cross_module_data[parseInt(resp.data[i]['level'])] == undefined) {
            cross_module_data[parseInt(resp.data[i]['level'])] = { module: parseInt(resp.data[i]['level']), module_show: true, level_data: [{ level: resp.data[i]['level'], branch_data: [resp.data[i]] }] }
          } else {
            console.log(cross_module_data)
            var tt = cross_module_data[parseInt(resp.data[i]['level'])];

            var flag = true;
            for (let k = 0; k < tt['level_data'].length; k++) {
              if (resp.data[i]['level'] == tt['level_data'][k]['level']) {
                tt['level_data'][k]['branch_data'].push(resp.data[i]);
                flag = false;
              }
            }
            if (flag) {
              tt['level_data'].push({ level: resp.data[i]['level'], branch_data: [resp.data[i]] })
            }

            cross_module_data[parseInt(resp.data[i]['level'])] = tt;
          }
        }
      }
      console.log(cross_module_data);
      console.log(apprval_data);
      this.moduledata = Object.values(module_data);
      this.Apprmoduledata = Object.values(apprval_data);
      this.crossmoduledata1 = Object.values(cross_module_data);
      console.log(this.crossmoduledata1);
      console.log(this.Apprmoduledata);
      this.l_flow_flag = false;
      this.c_flow_flag = false;
      this.u_flow_flag = true;


      $('.nav-tabs a[href="#tab-3"]').tab('show')

    } else {

    }
  }
  gotocrete() {
    this.refresh();
    this.l_flow_flag = false;
    this.c_flow_flag = true;
    this.u_flow_flag = false;

  }
  async Update() {

    var data = [];
    for (let i = 0; i < this.moduledata.length; i++) {
      var pp = this.moduledata[i]['branch_data']
      for (let j = 0; j < pp.length; j++) {
        pp[j]['department'] = 'MODULE';
        data.push(pp[j])
      }
    }

    for (let i = 0; i < this.crossmoduledata1.length; i++) {
      var level_data = this.crossmoduledata1[i]['level_data']
      for (let j = 0; j < level_data.length; j++) {
        var branch_data = level_data[j]['branch_data']
        for (let k = 0; k < branch_data.length; k++) {
          branch_data[k]['department'] = 'CRROS-MODULE';
          data.push(branch_data[k])
        }
      }
    }

    for (let i = 0; i < this.Apprmoduledata.length; i++) {
      var pp = this.Apprmoduledata[i]['branch_data']
      for (let j = 0; j < pp.length; j++) {
        pp[j]['department'] = 'APPROVAL';
        data.push(pp[j])
      }
    }


    for (let i = 0; i < data.length; i++) {
      if (data[i]['condition_exists']) {
        data[i]['condition_exists'] = 1
      } else {
        data[i]['condition_exists'] = 0
      }

      if (data[i]['sent_to_vendor']) {
        data[i]['sent_to_vendor'] = 1
      } else {
        data[i]['sent_to_vendor'] = 0
      }

      if (data[i]['all_user_approval_req']) {
        data[i]['all_user_approval_req'] = 1
      } else {
        data[i]['all_user_approval_req'] = 0
      }
    }

    console.log(data)
    this.spinner.show();
    this.FlowObj['b_acct_id'] = this.b_acct_id;
    data.map(x => {
      x['role_cd'] = x['role_cd'].join(",");
    })
    this.FlowObj['data'] = data;
    this.FlowObj['module_cd'] = this.selectedModuleForWorkFlow;
    this.FlowObj['comment'] = this.selectedModuleForWorkFlow + ' ka work Flow';
    this.FlowObj['update_user_id'] = this.erpUser.user_id;
    this.FlowObj['status'] = 'ACTIVE';
    console.log(this.FlowObj)
    var resp = await this.mainServiceMd.updateNewWorkflow(this.FlowObj);
    if (resp['error'] == false) {
      this.spinner.hide();
      await this.getAllActiveWorkFlow();

      this.toastr.success('Updated Successfully ');
      this.gotolist()
    }
    else {
      this.spinner.hide();
      this.toastr.error(resp['data']);
    }

  }

  birnaryObj: any = { 1: 'YES', 0: 'NO' }
  viewData: any = []
  selectedApproval: any = {}
  async viewRule(element: any) {
    console.log(element);
    let obj: any = new Object();
    obj['b_acct_id'] = this.b_acct_id;
    obj['status'] = 'ACTIVE';
    obj['doc_type'] = element['doc_type'];
    obj['module_cd'] = element['module_cd'];
    var resp = await this.mainServiceMd.getWorkflows(JSON.stringify(obj));
    console.log(resp)
    if (resp['error'] == false) {
      console.log(resp.data);
      this.viewData = resp.data;

      for (let i = 0; i < this.viewData.length; i++) {
        if (this.viewData[i]['data'] != null) {
          let data = JSON.parse(this.viewData[i]['data'])
          let dummy = []
          for (let j = 0; j < data.length; j++) {
            let ob;
            ob = data[j]['selected_field'] + '( ' + data[j]['selected_oprater'] + '  -  ' + data[j]['value'] + ')'
            dummy.push(ob)
          }
          this.viewData[i]['data_desc'] = dummy.join()
        }
      }

      $('#workflow').modal('show');
    } else {
      this.viewData = [];
      Swal.fire('Error', resp.data, 'error');
    }
  }

}
